<template>
  <div class="SchoolSelection">
    <div class="class-head SchoolSelection-header" style="z-index:2">
      <div class="plan-selector">
        <div @click="changeBtn">
          <span v-cloak class="nowarp">{{ yearName }}&nbsp;&nbsp;{{ sessionName }}</span>
          <i class="iconfont">&#xe620;</i>
        </div>
        <div @click="show = true">
          <span v-cloak class="nowarp">{{ selSemester.ClassTableName }}</span>
          <i class="iconfont">&#xe620;</i>
        </div>
      </div>
      <ul class="yd-scrollnav-tab-item">
        <li
          v-for="(item, index) in week"
          :key="index"
          :class="type === index ? 'active_tab' : ''"
          @click="changeTab(index)"
        >
          <p v-cloak>{{ item.Name }}</p>
        </li>
      </ul>
      <div class="radius" v-if="cloumns.length > 0" />
    </div>
    <!-- 学年学期弹框 -->
    <div>
      <div v-if="iShow" class="report-search-box" />
      <div v-if="iShow" class="report-search-box-content">
        <div class="y-list">
          <div :class="isYIndex === -1 ? 'active' : ''" @click="yearClick({ ID: 0 }, -1)">
            所有学年
          </div>
          <div v-for="(item, index) in yearData" :key="item.ID">
            <div
              v-cloak
              @click="yearClick(item, index)"
              :class="isYIndex === index ? 'active' : ''"
            >
              {{ item.Name }}
            </div>
          </div>
        </div>
        <div class="s-list">
          <div
            :class="isSIndex === -1 ? 'active' : ''"
            @click="sessionClick({ AcademicSessionID: 0 }, -1)"
          >
            所有学期
          </div>
          <div v-for="(item, index) in sessionData" :key="item.AcademicSessionID">
            <div
              @click="sessionClick(item, index)"
              v-cloak
              :class="isSIndex === index ? 'active' : ''"
            >
              {{ item.AcademicSessionName }}
            </div>
          </div>
        </div>
        <div class="btm-btn" @click="handleClick">
          <span>确定</span>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="show" :actions="myItems" cancel-text="取消" @select="PlanSelected" />

    <!-- 具体的课程表 -->
    <div
      class="class_info"
      :style="{
        'margin-top': week.length > 0 ? '35vh' : '13.125vh',
        padding: week.length > 0 ? '20px' : '0'
      }"
    >
      <ul v-if="cloumns.length > 0">
        <li v-for="(item, index) in cloumns" :key="index">
          <img src="@/assets/homeSchool/clock-roundness-gray@2x.png" alt v-if="index === 0" />
          <img v-else src="@/assets/homeSchool/clock-roundness-blue@2x.png" alt />
          <span v-cloak>{{ item.AMorPMOrderName }}</span>
          <p
            v-cloak
            :style="{ color: bg[index % 5].color, background: bg[index % 5].background }"
            @click="showDetail(item)"
          >
            {{
              item.SubjectName
                ? item.SubjectName.slice(0, item.SubjectName.length - 1)
                : item.SubjectName
            }}
          </p>
        </li>
      </ul>
      <no-data v-else :noData="暂无选课结果" :needBg="true" class="footer"></no-data>
      <!-- <div v-else class="xy-phone-no-data" style="margin-top: 70%">
        <img src="@/assets/common/moblie-no-data.png" />
        <p>暂无选课结果</p>
      </div> -->
    </div>
    <!-- 学年 -->
    <van-action-sheet v-model="showYear" :actions="yearData" cancel-text="取消" />
    <!-- 学期 -->
    <van-action-sheet v-model="showSession" :actions="sessionData" cancel-text="取消" />
  </div>
</template>

<script>
import { Dialog } from 'vant'
/*
 *  本文件仅从原项目复制并简易调整而来
 *  原作者：李原，王丹
 *  迁移自：2019-11-5 版本，宋培英修改
 */
export default {
  name: 'School',
  data() {
    return {
      iShow: false,
      StudentID: '',
      yearData: [], //排课方案
      yearId: 0, //选择的学年ID
      sessionId: 0, //选择的学期ID
      myItems: [],
      yearName: '请选择学年学期',
      sessionName: '请选择学期',
      isYIndex: -1, //选择的学年在数组中的下标
      isSIndex: -1, //选择的学期在数组中的下标
      yName: '所有学年', //临时保存
      sName: '所有学期',
      showYear: false,
      showSession: false,
      weekTable: [],
      sessionData: [], //学期数组
      show: false,
      type: 0,
      selSemester: { ClassTableName: '请选择方案' }, //选择的方案
      sectionList: [
        '1节',
        '2节',
        '3节',
        '4节',
        '5节',
        '6节',
        '7节',
        '8节',
        '9节',
        '10节',
        '11节',
        '12节'
      ],
      zaoData: ['早1', '早2'],
      wanData: ['晚1', '晚2', '晚3', '晚4'],
      reslutData: [], //一周上课时间结构
      allSubjectName: [], //一周上课所有课程
      week: [], //周时间
      cloumns: [], //每天有多少节课
      bg: [
        { background: 'rgba(52,121,205,0.1)', color: 'rgba(38, 100, 209, 1)' },
        { background: 'rgba(237,250,238,1)', color: 'rgba(9,175,24,1)' },
        { background: 'rgba(88,72,237,0.1)', color: 'rgba(88,72,237,1)' },
        { background: 'rgba(242,155,42,0.2)', color: 'rgba(242,155,42,1)' },
        { background: 'rgba(255,240,236,1)', color: 'rgba(248,52,1,1)' },
        { background: 'rgba(88,72,237,1)', color: 'rgba(159,6,235,1)' }
      ],
      temp_NavZIndex: 1
    }
  },
  computed: {
    childData() {
      return this.$store.state.parentInfo.childData
    }
  },
  methods: {
    // 改变课名称 如：am 1改为早1
    getWeekClass(val) {
      var arr = ['一', '二', '三', '四', '五', '六', '日']
      var that = this
      that.cloumns = []
      that.week = []
      val.map(function(item, index) {
        item.map(function(ins, index2) {
          if (index === 0) {
            that.week.push({
              Name: '周' + arr[ins.Day]
              // Day: ins.Day
            })
          }
          if (index2 === that.type) {
            if (ins.AMorPM === 'MS') {
              ins.AMorPMOrderName = that.zaoData[ins.Order]
            }
            if (ins.AMorPM === 'AB') {
              // ins.AMorPMOrderName = '上午大课间'
            }
            if (ins.AMorPM === 'PB') {
              // ins.AMorPMOrderName = '下午大课间'
            }
            if (ins.AMorPM === 'NS') {
              // ins.AMorPMOrderName = '午休'
            }
            if (ins.AMorPM === 'ES') {
              ins.AMorPMOrderName = that.wanData[ins.Order]
            }
            if (ins.AMorPM === 'AM' || ins.AMorPM === 'PM') {
              ins.AMorPMOrderName = that.sectionList[ins.Order]
            }
            if (ins.AMorPMOrderName) {
              ins.SubjectName = ''
              that.cloumns.push(ins)
            }
          }
        })
      })
      // console.log(  that.cloumns)
    },
    // 点击筛选
    changeBtn() {
      this.iShow = !this.iShow
      if (this.iShow) {
        document.body.style.overflow = 'hidden'
        for (var i = 0; i < this.yearData.length; i++) {
          if (this.yearData[i].ID === this.yearId) {
            this.isYIndex = i
            this.yName = this.yearData[i].Name
          }
        }
        for (var j = 0; j < this.sessionData.length; j++) {
          if (this.sessionData[j].AcademicSessionID === this.sessionId) {
            this.isSIndex = j
            this.sName = this.sessionData[j].AcademicSessionName
          }
        }
      } else {
        document.body.style.overflow = ''
      }
    },
    // 点击学年
    yearClick(vals, i) {
      this.isYIndex = i
      if (this.isYIndex === -1) {
        this.yName = '所有学年'
      } else {
        this.yName = vals.Name
      }
      this.yearId = vals.ID
      this.sessionId = ''
      this.isSIndex = ''
      this.sName = ''
      this.getSession()
    },
    // 点击学期
    sessionClick(vals, i) {
      this.sessionId = vals.AcademicSessionID
      this.isSIndex = i
      if (this.isSIndex === -1) {
        this.sName = '所有学期'
      } else {
        this.sName = vals.AcademicSessionName
      }
    },
    // 点击确定
    handleClick() {
      if (this.sessionId === '') {
        this.xy.msgError('请选择学期')
      } else {
        document.body.style.overflow = ''
        this.yearName = this.yName
        this.sessionName = this.sName
        this.iShow = false
        this.type = 0 //默认选中周一
        this.week = []
        this.cloumns = []
        this.GetArrangeSupervisorByStudentMobile()
      }
    },
    // 切换周一至周日
    changeTab(val) {
      this.type = val
      var that = this
      this.getWeekClass(this.reslutData)
      that.allSubjectName.forEach(function(item) {
        if (item.Day === that.type && that.cloumns.length > 0) {
          that.cloumns.forEach(function(ins, index) {
            if (ins.AMorPM === item.AMorPM && ins.AMorPMOrder === item.AMorPMOrder) {
              ins.SubjectName += item.SubjectName + '/'
              that.$set(that.cloumns, index, ins)
            }
          })
        }
      })
    },
    // 获取学年,并找到当前学年
    async GetYearList() {
      let res = await this.xyapi.get(this.$store.state.apiPath + '/xy/comm/YearList')
      if (res.success) {
        this.yearData = res.data
        if (this.yearData.length > 0) {
          for (var i = 0; i < this.yearData.length; i++) {
            if (this.yearData[i].IsCurrent) {
              this.yearName = this.yearData[i].Name
              this.yearId = this.yearData[i].ID
            }
          }
          this.getSession()
        } else {
          this.yearName = '请选择学年学期'
        }
        this.sessionName = ''
      } else {
        this.xy.msgError(res.msg)
      }
    },
    // 根据选择的学年获取学期
    async getSession() {
      var that = this
      that.sessionData = []
      let params = { yearID: that.yearId }
      let res = await this.xyapi.get(this.$store.state.apiPath + '/xy/comm/SessionList', params)
      if (res.success) {
        that.sessionData = res.data
        if (that.sessionData.length > 0) {
          for (var i = 0; i < that.sessionData.length; i++) {
            if (that.sessionData[i].IsCurrent) {
              that.sessionName = that.sessionData[i].AcademicSessionName
              that.sessionId = that.sessionData[i].AcademicSessionID
              that.GetArrangeSupervisorByStudentMobile()
            }
          }
        }
      }
    },
    // 根据选择的学年学期，获取方案
    async GetArrangeSupervisorByStudentMobile() {
      var that = this
      let params = {
        yearId: that.yearId,
        academicSessionID: that.sessionId,
        StudentID: that.StudentID
      }
      let res = await this.xyapi.get(
        this.$store.state.apiPath + '/api/StudentOnLineSelectCourse/GetSelectCourseSchoolByID',
        params
      )
      if (res.success) {
        if (res.data.length > 0) {
          that.semesterList = res.data
          that.selSemester = res.data[0]
          that.GetClassTableTimeAll()
        } else {
          that.semesterList = []
          that.selSemester = { ClassTableName: '该学期暂无方案' }
        }
        that.CreatScheme()
      } else {
        this.xy.msgError(res.msg)
        this.xy.unloading()
      }
    },
    //生成方案弹出框
    CreatScheme() {
      var that = this
      this.myItems = []
      this.semesterList.forEach(function(item) {
        that.myItems.push({
          name: item.ClassTableName,
          data: item
        })
      })
    },
    PlanSelected(item) {
      this.selSemester = item.data
      this.GetClassTableTimeAll()
      this.show = false
    },
    // 获取周课时间结构
    async GetClassTableTimeAll() {
      var that = this
      let params = {
        classTableID: this.selSemester.ClassTableID
      }
      let res = await this.xyapi.get(
        this.$store.state.apiPath + '/api/ClassTableTime/GetClassTableTimeAll',
        params
      )
      if (res.success) {
        if (res.data.length > 0) {
          var val = res.data

          that.reslutData = val
          that.getWeekClass(val)
          that.getSubject()
        }
      } else {
        this.xy.msgError(res.msg)
      }
      // this.getSubject()
    },
    //获取校本选课结果
    async getSubject() {
      var that = this
      this.xy.loading()
      this.showsession = true
      let params = {
        classTableID: that.selSemester.ClassTableID,
        StudentID: that.StudentID
      }
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          '/api/StudentOnLineSelectCourse/GetSchoolBasedGrabOnLineResultList',
        params
      )
      if (res.success) {
        if (res.data) {
          // var val = res.data.Results;
          that.allSubjectName = res.data.Results
          that.allSubjectName.forEach(function(item) {
            if (item.Day === that.type && that.cloumns.length > 0) {
              that.cloumns.forEach(function(ins, index) {
                if (ins.AMorPM === item.AMorPM && ins.AMorPMOrder === item.AMorPMOrder) {
                  ins.SubjectName += item.SubjectName + '/'
                  that.$set(that.cloumns, index, ins)
                }
              })
            }
          })
        }
      } else {
        this.xy.msgError(res.msg)
      }
      this.xy.unloading()
    },
    showDetail(item) {
      if (item.SubjectName) {
        Dialog.alert({
          message: item.SubjectName.slice(0, item.SubjectName.length - 1)
        })
      }
    }
  },
  created: function() {
    // this.getWeekTimeTable()
    this.$store.commit('changeNavBg', true)
    this.StudentID = this.childData.ChildrenID
    this.GetYearList()
  },
  mounted: function() {
    let navBar = document.getElementById('xy-navBar--isTransparent')
    this.temp_NavZIndex = navBar.style.zIndex
    navBar.style.zIndex = 100
  },
  beforeDestroy: function() {
    this.$store.commit('changeNavBg', false)
    let navBar = document.getElementById('xy-navBar--isTransparent')
    if (navBar instanceof HTMLElement) {
      navBar.style.zIndex = this.temp_NavZIndex
    }
  }
}
</script>

<style lang="less" scoped>
// 扩展菜单高度，使其能够完整显示（将成为多行）
::v-deep .van-action-sheet__item {
  height: auto;
  min-height: 50px;
}

/*
  * 引自 YDUI - 滚动导航
  * http://vue.ydui.org/docs/#/scrollnav
  */

.yd-scrollnav {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.yd-scrollnav,
.yd-scrollnav-tab {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.yd-scrollnav-tab {
  position: relative;
}

.yd-scrollnav-tab-item {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.yd-scrollnav-tab-item > li {
  padding: 0 20px;
  font-size: 28px;
  display: inline-block;
  position: relative;
  height: inherit;
}

.yd-scrollnav-tab-item > li.yd-scrollnav-current {
  color: currentColor !important;
  padding-left: 32px;
}

.yd-scrollnav-tab-item > li.yd-scrollnav-current > i {
  width: 32px;
  height: inherit;
  position: absolute;
  top: 0;
  left: 0.5px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.yd-scrollnav-tab-item > li.yd-scrollnav-current > i:before {
  content: '\E651';
  font-family: YDUI-INLAY;
  font-size: 32px;
  line-height: 1;
}

.yd-scrollnav-tab-item > li > span,
.yd-scrollnav-toggle {
  height: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.yd-scrollnav-toggle {
  width: 100px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.yd-scrollnav-toggle:after {
  content: '\E68C';
  font-family: YDUI-INLAY;
  display: block;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: -webkit-transform 0.08s linear;
  transition: -webkit-transform 0.08s linear;
  transition: transform 0.08s linear;
  transition: transform 0.08s linear, -webkit-transform 0.08s linear;
  font-size: 32px;
  color: currentColor;
}

.yd-scrollnav-toggle-active:after {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.yd-scrollnav-unfold {
  position: absolute;
  z-index: 2;
  width: 100%;
  top: 0;
  pointer-events: none;
  opacity: 0;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-transition: all 0.08s linear;
  transition: all 0.08s linear;
}

.yd-scrollnav-unfold-active {
  opacity: 1;
  -webkit-transform: translate(0);
  transform: translate(0);
}

.yd-scrollnav-unfold-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  border-width: 0 0 1px;
  border-style: solid;
}

.yd-scrollnav-unfold-header > div {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 30px;
  font-size: 28px;
  color: #333;
}

.yd-scrollnav-unfold-header > span {
  width: 100px;
}

.yd-scrollnav-unfold > ul {
  pointer-events: auto;
  overflow: hidden;
  padding-bottom: 20px;
  padding-top: 20px;
}

.yd-scrollnav-unfold > ul > li {
  float: left;
  width: 33.333%;
  padding-left: 30px;
  line-height: 70px;
  font-size: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.yd-scrollnav-unfold > ul > li.yd-scrollnav-current {
  color: currentColor !important;
}

.yd-scrollnav-content {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>

<style lang="less" scoped>
/* 头部背景设置：将整个容器设置为绝对定位 */
.SchoolSelection {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  &-header {
    position: fixed;
    z-index: 2;
    top: 0;
    width: 100%;
    height: 480px;
    padding-top: 145px;
    background: url('~@/assets/homeSchool/roundBar-blue@2x.png') no-repeat 0 / cover #0958e8;
  }
}
</style>

<style lang="less" scoped>
.plan-selector {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 60px;
  & > div {
    width: 320px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 30px;
    background: rgba(0, 0, 0, 0.15);
    padding: 0 20px;
    font-size: 24px;
    color: #fff;
    & > i {
      font-size: 36px;
    }
  }
}

.nowarp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 84%;
}

/* 星期样式 */
.yd-scrollnav-tab-item {
  padding: 0 40px;
}

.yd-scrollnav-tab-item > li {
  width: 110px;
  height: 110px;
  background: rgba(249, 249, 249, 0.2);
  border-radius: 34px;
  font-size: 30px;
  padding: 20px;
  margin-right: 30px;
  text-align: center;
  /* opacity: 0.2; */
}

.yd-scrollnav-tab-item > li > p:first-child {
  margin-bottom: 30px;
  color: #fff;
  font-weight: bold;
}

/* .yd-scrollnav-tab-item>li>p:last-child {
                  color: #F9F9F9;
              } */

.active_tab {
  /* opacity: 1 !important; */
  background: rgba(249, 249, 249, 1) !important;
  & > p:first-child {
    font-weight: bold;
    color: rgba(7, 0, 97, 1) !important;
  }
  & > p:last-child {
    font-weight: bold;
    color: #9d97bd !important;
  }
}

.radius {
  width: 100%;
  margin-top: 80px;
  padding: 30px 20px;
  background: rgba(249, 249, 249, 1);
  border-radius: 66px 66px 0 0;
  position: absolute;
  bottom: 0;
}

/* 具体的课程表 */
.class_info {
  width: 100%;
  background: rgba(249, 249, 249, 1);
  & > ul {
    border-left: 1px dashed #b6baca;
    margin-left: 16px;
    & > li {
      display: flex;
      margin-bottom: 60px;
      padding: 20px 30px;
      align-items: center;
      padding-left: 0;
      position: relative;
      height: 100px;
      & > img {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 0px;
        top: 0px;
        transform: translate(-50%);
      }
      & > span {
        position: absolute;
        z-index: 1;
        left: 40px;
        display: block;
        top: 10px;
        font-size: 28px;
      }
      & > p {
        width: 80%;
        background: rgba(52, 121, 205, 0.1);
        border-radius: 14px;
        font-size: 26px;
        font-weight: bold;
        color: rgba(38, 100, 209, 1);
        position: absolute;
        z-index: 1;
        left: 120px;
        display: block;
        top: -10px;
        padding: 30px 0 30px 30px;
        min-height: 100px;
      }
      &:last-child:before {
        content: '';
        width: 4px;
        height: 100%;
        background-color: rgba(249, 249, 249, 1);
        position: absolute;
        left: -3px;
      }
    }
  }
}

/* ----------------学年学期样式------------------ */

.report-search-box {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  &-content {
    position: absolute;
    width: 90%;
    z-index: 101;
    display: flex;
    border-top: 1px solid #eee;
    justify-content: space-around;
    background: #fff;
    height: 600px;
    color: #333;
    top: 100px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}

.y-list {
  border-right: 1px solid #eee;
}

.y-list,
.s-list {
  height: 500px;
  overflow-y: auto;
  width: 50%;
  text-align: left;
  padding-left: 50px;
}

.y-list div.active,
.s-list div.active {
  color: #4196ff;
}

.y-list > div,
.s-list > div {
  margin-top: 30px;
  font-size: 28px;
}

.btm-btn {
  position: absolute;
  bottom: 20px;
  width: 130px;
  text-align: center;
  background: #4196ff;
  height: 60px;
  line-height: 60px;
  border-radius: 80px;
  color: #fff;
}

.report-search-ys,
.card_site,
.ielts {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
